<template>
  <v-alert
    :color="color"
    style="position: fixed; right: 10px; left: 10px; margin-right: auto; margin-left: auto;"
    :style="{ bottom: bottom}"
    :value="show"
    class="ma-3"
    dense
    :class="{ 'alert-mobile': $mobileDetect.phone() || $mobileDetect.tablet() }"
    transition="slide-y-reverse-transition"
  >
    <v-row align="center">
      <v-col class="grow text-center">
        {{ text }}
      </v-col>
      <v-col class="shrink">
        <v-btn
          icon
          @click="$store.dispatch('setAlert', { bool: false, type: type, text: text })"
        >
          <v-icon color="white">
            fas fa-times
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
  export default {
    name: 'AlertApp',
    computed: {
      type () {
        return this.$store.state.alert.type
      },
      text () {
        return this.$store.state.alert.text
      },
      show () {
        return this.$store.state.alert.show
      },
      bottom () {
        let pos = 15
        if (this.$store.state.privacy) pos += 105
        return pos + 'px'
      },
      color () {
        switch (this.type) {
          case 'error':
            return 'red'
          case 'success':
            return 'green'
          default:
            return 'red'
        }
      },
    },
  }
</script>
<style scoped>
.v-alert {
  z-index: 10!important;
  height: auto;
  max-width: 900px;
  margin: 0 auto !important;
  opacity: 1;
  font-size: 20px;
}
.alert-mobile {
  right: 10px!important;
  left: 10px!important;
}
</style>
